<template>
  <section class="card_style">
    <div class="main_header">
      <h4 v-if="this.$route.params.id != undefined">
        {{ $t("edit client type portal") }}
      </h4>
      <h4 v-else>{{ $t("add client type portal") }}</h4>
    </div>
    <skeltonTitles v-if="this.$route.params.id && loading" />
    <form @submit.prevent="addService()" v-else>
      <div class="row">
        <!-- <h4>
            <i class="fa-solid fa-caret-left"></i>
            المرحله الاولي
          </h4> -->
        <div class="col-lg-4 col-md-4 col-12">
          <!-- <div class="form-group">
            <label>{{ $t("title") }}</label>
            <div class="accordion" id="accordionExample1">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    {{ $t("title") }}
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample1"
                >
                  <div class="accordion-body">
                    <div
                      class="form-group"
                      v-for="(blog_title, index) in Form.title"
                      :key="index"
                    >
                      <label for="name"
                        >{{ $t("title") }} ({{ blog_title.locale }})</label
                      >
                      <input
                        type="text"
                        :placeholder="$t('name')"
                        class="form-control"
                        :id="`name${index}`"
                        v-model="blog_title.title"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span class="input-errors" v-if="v$.Form.title.$error">{{
              v$.Form.title.$errors[0].$message
            }}</span>
          </div> -->

          <div class="form-group">
            <TabView>
              <TabPanel
                v-for="(car, index) in client_portal"
                :key="index"
                :class="[car.title !== '' ? 'text-success' : '']"
                :header="$t('title') + ' - ' + car.locale"
              >
                <div class="form-group mb-0">
                  <input
                    type="text"
                    :placeholder="$t('title')"
                    class="form-control"
                    :id="`title${index}`"
                    v-model="car.title"
                  />
                  <!-- Add any additional content specific to each tab here -->
                </div>
              </TabPanel>
            </TabView>
            <span class="input-errors" v-if="v$.client_portal.$error">{{
              v$.client_portal.$errors[0].$message
            }}</span>
          </div>
        </div>
        <br />
        <div class="col-lg-4 mt-4">
          <label for="type" class="fw-bold mb-4"
            >{{ $t("Manual code") }}

            <sub class="info">
              <b>( {{ $t("unique code for type client") }} )</b>
            </sub>
          </label>
          <input
            class="form-control"
            type="text"
            :placeholder="$t('Manual code')"
            v-model="manual_code"
          />
          <span class="input-errors" v-if="v$.manual_code.$error"
            >{{ v$.manual_code.$errors[0].$message }}
          </span>
        </div>
        <div
          class="col-lg-4 col-md-4 col-12 d-flex align-items-center justify-content-center"
        >
          <div
            class="d-flex align-items-center justify-content-center gap-3 flex-column"
          >
            <label>{{ $t("default") }}</label>
            <Checkbox v-model="checked" :binary="true" />
          </div>
        </div>
      </div>

      <button type="submit" class="add btn PrimaryButton">
        {{ $t("save") }}
      </button>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
// import Multiselect from "vue-multiselect";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import skeltonTitles from "@/components/skelton/skeltonTitles.vue";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";

import Checkbox from "primevue/checkbox";

export default {
  name: "add-service",
  data() {
    return {
      loading: true,
      v$: useVuelidate(),
      languages: ["ar", "en", "id"],
      client_portal: [],
      manual_code: "",
      fileData: null,
      portal: 1,
      Form: {
        title: [],
      },

      checked: false,
    };
  },
  validations() {
    return {
      client_portal: this.client_portal.map(() => {
        return {
          title: { required },
        };
      }),
      manual_code: { required },
    };
  },

  methods: {
    setCarCatName() {
      this.languages.forEach((language) => {
        this.client_portal.push({
          locale: language,
          title: "",
        });
      });
    },

    addService() {
      this.v$.$validate();
      if (!this.v$.$error) {
        if (this.$route.params.id != undefined) {
          const params = new URLSearchParams();

          params.append("manual_code", this.manual_code);

          if (this.portal == 1) {
            params.append("is_portal", this.portal);
          }

          params.append("is_default", this.checked ? 1 : 0);

          // this.Form.title.forEach((ele) => {
          //   params.append(`title_${ele.locale}`, ele.title);
          // });

          this.client_portal.forEach((car) => {
            params.append(`title_${car.locale}`, car.title);
          });

          axios
            .put(`/client_types/${this.$route.params.id}`, params)
            .then(() => {
              Swal.fire({
                title: "",
                text: this.$t("save_successfuly"),
                icon: "success",
              });
              this.$router.push("/client-type-portal");
            })
            .catch((error) => {
              Swal.fire({
                title: "",
                text: error.response.data.message,
                icon: "error",
              });
            });
        } else {
          const formData = new FormData();
          formData.append("manual_code", this.manual_code);
          formData.append("is_portal", this.portal);

          formData.append("is_default", this.checked ? 1 : 0);

          // this.Form.title.forEach((ele) => {
          //   formData.append(`title_${ele.locale}`, ele.title);
          // });

          this.client_portal.forEach((car) => {
            formData.append(`title_${car.locale}`, car.title);
          });

          axios
            .post(`/client_types`, formData)
            .then(() => {
              Swal.fire({
                title: "",
                text: this.$t("save_successfuly"),
                icon: "success",
              });
              this.$router.push("/client-type-portal");
            })
            .catch((error) => {
              Swal.fire({
                title: "",
                text: error.response.data.message,
                icon: "error",
              });
            });
        }
      }
    },
  },

  mounted() {
    if (this.$route.params.id != undefined) {
      axios.get(`/client_types/${this.$route.params.id}`).then((res) => {
        this.client_portal = res.data?.data?.titles;
        console.log(res.data.data);
        console.log(this.client_portal, "ww");
        this.client_portal?.map((car) => {
          return {
            locale: car.locale,
            title: car.title,
          };
        });
        this.manual_code = res.data.data.manual_code;
        this.checked = res.data.data.is_default == 1 ? true : false;

        this.loading = false;
        // console.log(this.Form.title);
      });
    }
    this.setCarCatName();
  },
  components: {
    skeltonTitles,
    TabView,
    TabPanel,
    Checkbox,
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  margin-bottom: 1rem;
}

.btn-stratigy {
  background-color: #0a909b;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
}

input.form-control {
  padding: 0.8rem !important;
}
.fa-caret-left {
  color: #0a909b;
}
.info {
  font-size: 0.7rem;
}
</style>
